var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 0H6.66663C7.58744 0 8.33326 0.92082 8.33326 1.66665V4.05339C8.33326 4.97421 7.58744 5.72003 6.66663 5.72003H1.66663C0.745818 5.72003 0 4.79921 0 4.05339V1.66665C0 0.745825 0.745818 0 1.66663 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 12.2798H16.3335C17.2543 12.2798 18.0001 13.2006 18.0001 13.9464V16.3332C18.0001 17.254 17.2543 17.9998 16.3335 17.9998H11.3335C10.4127 17.9998 9.66687 17.079 9.66687 16.3332V13.9464C9.66687 13.0256 10.4127 12.2798 11.3335 12.2798Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 0H16.3335C17.2543 0 18.0001 0.92082 18.0001 1.66665V8.85333C18.0001 9.77415 17.2543 10.52 16.3335 10.52H11.3335C10.4127 10.52 9.66687 9.59915 9.66687 8.85333V1.66665C9.66687 0.745825 10.4127 0 11.3335 0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.47998H6.66663C7.58744 7.47998 8.33326 8.4008 8.33326 9.14663V16.3333C8.33326 17.2541 7.58744 18 6.66663 18H1.66663C0.745818 18 0 17.0791 0 16.3333V9.14663C0 8.22581 0.745818 7.47998 1.66663 7.47998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.4c971ed43c47cc8018454e1d09265e94.svg";
export { ForwardRef as ReactComponent };